<template>
  <v-navigation-drawer
    class="py-5"
    width="500"
    :temporary="true"
    location="right"
    v-model="shareTrigger"
    @update:modelValue="shareTrigger = $event"
    :absolute="true"
    scrim="transparent"
    elevation="1"
    :disable-resize-watcher="true"
    :disable-route-watcher="true"
  >
    <v-container>
      <div v-if="parcelLoading" class="d-flex justify-center align-center pa-6">
        <v-progress-circular indeterminate color="secondary" />
      </div>
      <v-alert v-else-if="parcelError" type="error" variant="tonal" density="compact">
        {{ parcelError }}
      </v-alert>
      <div ref="parcelMountPoint"></div>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "SidebarShare",
  props: {
    dialogShare: Boolean,
    drawerShare: Boolean,
    realm: String,
    root: String,
    id: String,
    mashup: {},
    apiUrl: {
      type: String,
      default: "",
    },
    palette: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:mashup", "update:drawerShare"],
  data() {
    return {
      parcel: null,
      parcelLoading: false,
      parcelError: null,
    };
  },
  watch: {
    async shareTrigger(isOpen) {
      if (isOpen) {
        await this.$nextTick();
        await this.mountShareParcel();
      } else {
        this.unmountShareParcel();
      }
    },
  },
  beforeUnmount() {
    this.unmountShareParcel();
  },
  computed: {
    shareTrigger: {
      get() {
        return this.drawerShare;
      },
      set(value) {
        this.$emit("update:drawerShare", value);
      },
    },
    localMashup: {
      get() {
        return this.mashup;
      },
      set(value) {
        this.$emit("update:mashup", value);
      },
    },
  },
  methods: {
    async mountShareParcel() {
      if (this.parcel) return;

      this.parcelLoading = true;
      this.parcelError = null;
      await this.$nextTick();

      try {
        if (!window.importShim) throw new Error('importShim not available');

        const el = this.$refs.parcelMountPoint;
        if (!el || !document.documentElement.contains(el)) {
          throw new Error('Mount point not in document');
        }

        if (!this.apiUrl) {
          throw new Error('apiUrl missing');
        }
        if (!this.localMashup?._id) {
          throw new Error('resourceData._id missing');
        }

        const [parcelConfig, { mountRootParcel }] = await Promise.all([
          window.importShim('demf-share-form'),
          window.importShim('single-spa'),
        ]);

        this.parcel = mountRootParcel(parcelConfig, {
          domElement: el,
          realm: this.realm,
          palette: this.palette,
          apiUrl: this.apiUrl,
          root: this.root,
          resourceData: this.localMashup,
        });
        await this.parcel.mountPromise;
      } catch (err) {
        console.error('[SidebarShare] Failed to mount share parcel:', err);
        this.parcelError = `Share service unavailable: ${err.message}`;
      } finally {
        this.parcelLoading = false;
      }
    },
    unmountShareParcel() {
      if (this.parcel) {
        this.parcel.unmount().catch(console.error);
        this.parcel = null;
      }
      this.parcelError = null;
      this.parcelLoading = false;
    },
  },
};
</script>
